import { Component, ViewEncapsulation } from '@angular/core';
import { RenderConfig } from '@app/finxone-web-frontend/app/lib/utils/get-component.utils';
import {
  BaseCssProperties,
  ImportUsers,
  ProviderClass,
  SectionNames,
  UiZoneWidgetConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Subject, debounceTime } from 'rxjs';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';
import { MetadataService } from '../../../../lib/services/metadata-service/metadata-service.service';

@Component({
  standalone: false,
  selector: 'finxone-platform-import-user',
  templateUrl: './import-user.component.html',
  styleUrls: ['./import-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImportUserComponent {
  isEditUser = false;
  isShowUser = true;
  firstName: string;
  lastName: string;
  searchNotifier = new Subject();
  isImportUserApiProcess: boolean;
  importusers: ImportUsers[];
  isImportUserApiCalled: boolean;

  public widgetConfig: UiZoneWidgetConfig;
  colorTextAlignStyle: baseCssConfigStyle;
  borderStyle: baseCssConfigStyle;
  contentStyle: baseCssConfigStyle; //property to set css in main div
  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<any>,
    private metadataService: MetadataService,
  ) {}
  static isRender(attributes: RenderConfig) {
    if (attributes.isEdit && attributes.sectionName == SectionNames.ADD_USER_WIDGET_SECTION) return false;
    return true;
  }
  ngOnInit() {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
    }
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.widgetConfig.attributes, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
    ]);
    this.borderStyle = this.configService.getSpecificBaseCssStyle(this.widgetConfig.attributes, [
      BaseCssProperties.BORDER,
      BaseCssProperties.BACKGROUND_COLOR,
    ]);

    this.colorTextAlignStyle = this.configService.getSpecificBaseCssStyle(this.widgetConfig.attributes, [
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.V_ALIGN,
    ]);

    if (this.configService.getActiveConfigType()?.isWorkflow) {
      this.getImportUsers();
      this.lastName = 'Miller';
      this.firstName = 'Annie';
    }

    this.searchNotifier.pipe(debounceTime(1000)).subscribe((data) => {
      this.getImportUsers();
    });
  }

  showImportUser() {
    this.isShowUser = true;
  }

  showHideImportUser() {
    this.isShowUser = !this.isShowUser;
  }

  getImportUsers() {
    this.isImportUserApiProcess = true;
    const importUserPayload = {
      page: 1,
      size: 10,
      first_name: this.firstName,
      last_name: this.lastName,
    };
    this.metadataService.getImportUsers(importUserPayload).subscribe((res: ImportUsers[]) => {
      this.isImportUserApiCalled = true;
      this.isImportUserApiProcess = false;
      if (res.length) {
        this.importusers = res;
      }
    });
  }

  showImportUserData(importuser: ImportUsers) {
    this.metadataService.importselecteduser.next(importuser);
  }
}
